class ProfessionalGroupModel {
  union_id = null;
  name = null;
  constructor(data) {
    if (data !== undefined) {
      let { union_id, name } = data;
      Object.assign(this, { union_id, name });
    }
  }
}

export default ProfessionalGroupModel;
